export enum EnumRoutes {
  whitePage = 'w',

  panel = 'painel',
  earnings = 'ganhos',
  indicate = 'indicar',
  partners = 'parceiros',
  usefulLinks = 'links-uteis',
  indications = 'indicacoes/locacao',
  indicateForm = 'indicar/formulario',
}

export type IType =
  | 'terreno'
  | 'locacao'
  | 'spot'
  | 'construtora'
  | 'marketplace'
  | 'parceiro'
  | 'franquia'
  | 'decoracao'
  | 'indicacao-fria';

export enum EnumType {
  terrain = 'terreno',
  location = 'locacao',
  spot = 'spot',
  builder = 'construtora',
  marketplace = 'marketplace',
  partner = 'parceiro',
  franchise = 'franquia',
  decor = 'decoracao',
  coldInvestment = 'indicacao-fria',
}

export type IParntersRoutes = typeof partnersRoutes;

export const partnersRoutes = {
  panel: {
    main: 'painel',
    name: 'Painel',
  },

  welcome: {
    main: `${EnumRoutes.whitePage}/intro`,
    name: 'Bem vindo(a)',
  },

  withdraw: {
    main: 'saque',
    name: 'Saque',
  },

  earnings: {
    main: 'ganhos',
    name: 'Ganhos',
    rescue: {
      main: 'resgate',
      name: 'Resgatar',
    },
  },

  questions: {
    main: 'duvidas',
    name: 'Dúvidas',
  },

  partners: {
    main: 'parceiros',
    name: 'Parceiros',
  },

  whitePage: { main: EnumRoutes.whitePage },

  usefulLinks: {
    main: EnumRoutes.usefulLinks,
    name: 'Links úteis',
  },

  indications: {
    main: 'indicacoes',
    name: 'Indicações',
    filter: {
      terrain: EnumType.terrain,
      location: EnumType.location,
      builder: EnumType.builder,
      partner: EnumType.partner,
    },
  },

  indicate: {
    main: 'indicar',
    name: 'Indicar',
    form: {
      main: 'formulario',
      terrain: EnumType.terrain,
      location: EnumType.location,
      spot: EnumType.spot,
      builder: EnumType.builder,
      marketplace: EnumType.marketplace,
      partner: EnumType.partner,
      franchise: EnumType.franchise,
      decor: EnumType.decor,
      coldInvestment: EnumType.coldInvestment,
    },
  },
  map: {
    main: 'mapa-terrenos',
    name: 'Mapa',
  },
  spotSalesMirror: {
    main: 'espelho-vendas-spot',
    name: 'Espelho de vendas SPOT',
  },

  editOrganization: {
    main: 'editar-organizacao',
    name: 'Editar Organização',
  },

  spotmatch: {
    main: 'spotmatch',
    name: 'Spotmatch',
    new: { main: 'novo', name: 'Novo Cliente' },
    detail: { main: ':leadId', name: 'Cliente' },
    edit: { main: ':leadId/editar', name: 'Editar Cliente' },
  },

  lancamentos: {
    main: 'lancamentos',
    name: 'Lançamentos',
  },

  revendas: {
    main: 'revendas',
    name: 'Revendas',
  },
};

export function validateWhitePage(url: string) {
  if (url.includes('/w/')) {
    return true;
  }
  return false;
}
